import React from "react";
import { Outlet, NavLink, Navigate } from "react-router-dom";
import Header from "@/components/app/Header";
import SEO from "@/components/app/SEO";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Users, Building2, FileText, ClipboardCheck, CreditCard, Truck, Settings, Activity, BarChart3, Send } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";

const items = [
  { to: "/admin", icon: LayoutDashboard, label: "Dashboard", end: true },
  { to: "/admin/analytics", icon: BarChart3, label: "Analytics" },
  { to: "/admin/dossiers/a-verifier", icon: ClipboardCheck, label: "Dossiers à vérifier" },
  { to: "/admin/utilisateurs", icon: Users, label: "Utilisateurs" },
  { to: "/admin/annuaire", icon: Building2, label: "Annuaire" },
  { to: "/admin/dossiers", icon: FileText, label: "Tous les dossiers" },
  { to: "/admin/paiements", icon: CreditCard, label: "Paiements PayPal" },
  { to: "/admin/envois", icon: Truck, label: "Envois postaux" },
  { to: "/admin/postal/mysendingbox", icon: Send, label: "MySendingBox (Live)" },
  { to: "/admin/integrations", icon: Settings, label: "Intégrations" },
  { to: "/admin/audit", icon: Activity, label: "Journal d'audit" },
];

export default function AdminLayout() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center">Chargement...</div>;
  if (!user) return <Navigate to="/connexion" replace />;
  if (user.role !== "admin") return <Navigate to="/espace" replace />;

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <SEO title="Administration" noindex />
      <Header />
      <div className="mx-auto max-w-7xl w-full px-4 sm:px-6 lg:px-8 py-8 flex-1">
        <div className="grid grid-cols-1 md:grid-cols-[240px_1fr] gap-8">
          <aside className="md:sticky md:top-24 h-fit">
            <div className="mb-3 px-3 text-[10px] uppercase tracking-widest text-muted-foreground font-semibold">Administration</div>
            <nav className="flex flex-col gap-1">
              {items.map((it) => (
                <NavLink
                  key={it.to}
                  to={it.to}
                  end={it.end}
                  data-testid={`admin-sidebar-${it.to.split("/").pop()}`}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                      isActive ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground hover:bg-secondary"
                    }`
                  }
                >
                  <it.icon className="h-4 w-4" />
                  {it.label}
                </NavLink>
              ))}
            </nav>
          </aside>
          <div><Outlet /></div>
        </div>
      </div>
      <Toaster position="top-right" richColors />
    </div>
  );
}
